// 小灯塔
export default [
  {
    path: '/lighthouse',
    name: 'lighthouse',
    meta: {
      pageTitle: '树学院',
      requiresAuth: true         // 是否需要登录
    },
    component: () => import('../page/lighthouse/home')
  },
  {
    path: '/lighthouse/income',
    name: 'lighthouseIncome',
    meta: {
      pageTitle: '我的收益',
      requiresAuth: true         // 是否需要登录
    },
    component: () => import('../page/lighthouse/income')
  },
  {
    path: '/lighthouse/detail/:courseId(\\d+)',
    name: 'lightDetail',
    meta: {
      pageTitle: '课程详情',
      requiresAuth: true        // 是否需要登录
    },
    component: () => import('../page/lighthouse/detail/index.page')
  },
  {
    path: '/lighthouse/classRoom',
    name: 'lighthouseClassRoom',
    meta: {
      pageTitle: '我的课堂',
      requiresAuth: true         // 是否需要登录
    },
    component: () => import('../page/lighthouse/classRoom')
  },
  {
    path: '/lighthouse/listenIndex/:courseId(\\d+)',
    name: 'listenIndex',
    meta: {
      pageTitle: '听课首页',
      requiresAuth: true         // 是否需要登录
    },
    component: () => import('../page/lighthouse/listenIndex')
  },
  {
    path: '/lighthouse/selection/:courseId(\\d+)',
    name: 'lighthouseSelection',
    meta: {
      pageTitle: '课程选集',
      requiresAuth: true         // 是否需要登录
    },
    component: () => import('../page/lighthouse/selection/index.page')
  },
  {
    path: '/lighthouse/coupon',
    name: 'lighthouseCoupon',
    meta: {
      pageTitle: '优惠券',
      requiresAuth: true        // 是否需要登录
    },
    component: () => import('../page/lighthouse/coupon/index.page')
  },
  {
    path: '/lighthouse/uc',
    name: 'lighthouseUc',
    meta: {
      pageTitle: '个人中心',
      requiresAuth: true         // 是否需要登录
    },
    component: () => import('../page/lighthouse/uc')
  },
  {
    path: '/lighthouse/my',
    name: 'lighthouseMy',
    meta: {
      pageTitle: '我的订单',
      requiresAuth: true         // 是否需要登录
    },
    component: () => import('../page/lighthouse/my')
  }
];



// WEBPACK FOOTER //
// ./src/user/router/lighthouse.js